import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'
import { filterShallowObject } from 'Services/extraObject'
import { stringify } from 'qs'

const endpoint = `${apiUrl.stable}`

const paramsSerializer = params => stringify(params, { arrayFormat: 'repeat' })

const filterNull = item => item !== null

/**
 * Returns a list of reviews of the signed company
 * @param {number} page
 * @param {ReviewSupplierOptions} options
 * @returns {Promise.<{ data: ApiReviewCompanyResult }>}
 */
 export const getUserReviews = (page = 1, options) => {
  const url = `${endpoint}/solicitante/avaliacoes/fornecedores`


  const {
    filter = '',
    rating = null,
    withReply = null
  } = options

  /** @type {ApiReviewCompanyOptions} */
  const paramList = {
    pageSize: 10,
    page: page,
    withReply: withReply,
    filter: filter,
    Rating: rating,
  }

  const query = filterShallowObject(paramList, filterNull)
  const headers = { ...jsonWebToken.header }

  return axios.post(url, query, {headers})
}

/**
 * Reply a negotiation's review
 * @param {number} idCompanyQuotation
 * @param {string} comment
 */
 export const addReviewReply = (idCompanyQuotation, comment) => {
  const url = `${endpoint}/solicitante/avaliacoes/replica/salvar`

  const headers = {
    ...jsonWebToken.header
  }

  const data = {
    idCompanyQuotation: idCompanyQuotation,
    comment: comment
  }

  return axios.post(url, data, { headers })
}

/**
 * Update a a negotiation's review reply
 * @param {number} replyId
 * @param {string} comment
 */
export const updateReviewReply = (replyId, comment) => {
  const url = `${endpoint}/solicitante/avaliacoes/replica/atualizar`

  const headers = {
    ...jsonWebToken.header
  }

  const data = {
    idCustomerEvaluation: replyId,
    comment: comment
  }

  return axios.put(url, data, { headers })
}



export default {
  getUserReviews,
  addReviewReply,
  updateReviewReply
}